"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingPrefix = void 0;
var LoggingPrefix;
(function (LoggingPrefix) {
    LoggingPrefix["Base"] = "[javascript-obfuscator]";
    LoggingPrefix["CLI"] = "[javascript-obfuscator-cli]";
})(LoggingPrefix = exports.LoggingPrefix || (exports.LoggingPrefix = {}));
